import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { DefinitionProvider } from "./providers/DefinitionProvider";
import "bootstrap/dist/css/bootstrap.min.css";
import { SocketProvider } from "./providers/socketProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const socketUrl =
  window.location.hostname === "localhost" ? "http://localhost:3000/" : "/";

root.render(
  <SocketProvider url={socketUrl}>
    <DefinitionProvider>
      <App />
    </DefinitionProvider>
  </SocketProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
